var App = App || {};

App.NowrapChevrons = (function ($) {
    'use strict';

    function Init() {
        const nowrapChevrons = $("a .nowrap-chevron");

        nowrapChevrons.each(function () {
            const iconHtml = "<span class=\"fa fal fa-chevron-right\"></span>";

            const trimmed = $(this).text().trim();
            const lastSpaceIndex = trimmed.lastIndexOf(' ');

            const before = trimmed.slice(0, lastSpaceIndex);
            const last = trimmed.slice(lastSpaceIndex + 1);

            if (lastSpaceIndex != -1 && lastSpaceIndex != trimmed.length) {
                // Group the last word with icon so they never wrap apart
                $(this).html(`<span class="text">${before} <span style="white-space:nowrap">${last} ${iconHtml}</span></span>`);
            }
        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.NowrapChevrons.Init();
});